import { Component, computed, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '../../service/layout.service';
import { AppConfigurator } from '../app.configurator';

@Component({
  selector: 'app-floating-configurator',
  imports: [ButtonModule, StyleClassModule, AppConfigurator],
  standalone: true,
  templateUrl: './floating-configurator.component.html',
  styleUrl: './floating-configurator.component.scss'
})
export class FloatingConfiguratorComponent {
  LayoutService = inject(LayoutService);

  isDarkTheme = computed(() => this.LayoutService.layoutConfig().darkTheme);

  toggleDarkMode() {
    this.LayoutService.layoutConfig.update((state) => ({
      ...state,
      darkTheme: !state.darkTheme
    }));
  }
}
